var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.67509 4.555H6.9804H8.96391H9.25568L9.4641 4.75918L10.2849 5.56327L10.4994 5.77347V6.07384V7.10034V7.39628L10.2902 7.6056L8.7895 9.10711V10.0943H7.36001V8.81117V8.51522L7.56922 8.3059L9.06993 6.80439V6.3742L8.67214 5.98449H7.28572L6.72734 6.568L5.69454 5.57967L6.464 4.77558L6.67509 4.555ZM8.71528 10.73H7.44462V11.8418H8.71528V10.73Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltip);
export default __webpack_public_path__ + "static/media/question_tooltip.e3db27b5f670b035cb021791e619ed46.svg";
export { ForwardRef as ReactComponent };